export const defaultProfileTranslations = {
  FIRST_NAME_REQUIRED_TITLE: 'First name',
  FIRST_NAME_REQUIRED_DESCRIPTION: 'First name should not be empty',
  FIRST_NAME_IS_STRING_TITLE: 'First name',
  FIRST_NAME_IS_STRING_DESCRIPTION: 'First name must be string',

  MIDDLE_NAME_IS_STRING_TITLE: 'Middle name',
  MIDDLE_NAME_IS_STRING_DESCRIPTION: 'Middle name must be string',

  LAST_NAME_REQUIRED_TITLE: 'Last Name Required',
  LAST_NAME_REQUIRED_DESCRIPTION: 'Last name is required',
  LAST_NAME_IS_STRING_TITLE: 'Last Name Required',
  LAST_NAME_IS_STRING_DESCRIPTION: 'Last name is required',

  EMAIL_INVALID_TITLE: 'Invalid Email Address',
  EMAIL_INVALID_DESCRIPTION: 'The email address entered is invalid. Please provide a valid email to proceed.',
  EMAIL_REQUIRED_TITLE: 'Email Address Required',
  EMAIL_REQUIRED_DESCRIPTION: 'Email Address is required.',
  EMAIL_VERIFIED_BOOLEAN_TITLE: 'Verified Failed',
  EMAIL_VERIFIED_BOOLEAN_DESCRIPTION: 'There was an issue verifying your email.  Please try again.',

  PASSWORD_REQUIRED_TITLE: 'Password',
  PASSWORD_REQUIRED_DESCRIPTION: 'Password should not be empty',
  PASSWORD_IS_STRING_TITLE: 'Password',
  PASSWORD_IS_STRING_DESCRIPTION: 'Password must be string',

  COUNTRY_REQUIRED_TITLE: 'Address Detail Required',
  COUNTRY_REQUIRED_DESCRIPTION: 'Country is required.',
  COUNTRY_IS_STRING_TITLE: 'Address Detail Required',
  COUNTRY_IS_STRING_DESCRIPTION: 'Country is required.',
  COUNTRY_IS_ISO31661ALPHA2_TITLE: 'Invalid Address Format',
  COUNTRY_IS_ISO31661ALPHA2_DESCRIPTION: 'Country must be a valid ISO31661 Alpha2 code',

  ADDRESS1_IS_STRING_TITLE: 'Address Detail Required',
  ADDRESS1_IS_STRING_DESCRIPTION: 'Address line one is required.',

  ADDRESS2_IS_STRING_TITLE: 'Address Detail Required',
  ADDRESS2_IS_STRING_DESCRIPTION: 'Address line two is required.',

  ADDRESS3_IS_STRING_TITLE: 'Address Detail Required',
  ADDRESS3_IS_STRING_DESCRIPTION: 'Address line three is required.',

  ADDRESS4_IS_STRING_TITLE: 'Address Detail Required',
  ADDRESS4_IS_STRING_DESCRIPTION: 'Address line four is required.',

  FLAT_NAME_IS_STRING_TITLE: 'Flat name',
  FLAT_NAME_IS_STRING_DESCRIPTION: 'Flat name must be string',

  PROPERTY_NUMBER_IS_STRING_TITLE: 'Invalid Property Number',
  PROPERTY_NUMBER_IS_STRING_DESCRIPTION: 'Please enter a valid property number to proceed.',

  CITY_REQUIRED_TITLE: 'Address Detail Required',
  CITY_REQUIRED_DESCRIPTION: 'City/Town is required.',
  CITY_IS_STRING_TITLE: 'Address Detail Required',
  CITY_IS_STRING_DESCRIPTION: 'City/Town is required.',

  POSTAL_CODE_REQUIRED_TITLE: 'Invalid Postal Code',
  POSTAL_CODE_REQUIRED_DESCRIPTION: 'Please enter a valid postal code to proceed.',
  POSTAL_CODE_IS_STRING_TITLE: 'Invalid Postal Code',
  POSTAL_CODE_IS_STRING_DESCRIPTION: 'Please enter a valid postal code to proceed.',

  DOB_REQUIRED_TITLE: 'Date Of Birth Required',
  DOB_REQUIRED_DESCRIPTION: 'Date of birth is required.',
  DOB_IS_STRING_TITLE: 'Date Of Birth Required',
  DOB_IS_STRING_DESCRIPTION: 'Date of birth is required.',
  DOB_IS_DATE_STRING_TITLE: 'Invalid Date Format',
  DOB_IS_DATE_STRING_DESCRIPTION: 'Date of birth must be in the format YYYY-MM-DD.',

  USERNAME_IS_STRING_TITLE: 'Invalid User Name',
  USERNAME_IS_STRING_DESCRIPTION: 'Please enter a valid user name to continue.',

  PROPERTY_NAME_IS_STRING_TITLE: 'Invalid Property Name',
  PROPERTY_NAME_IS_STRING_DESCRIPTION: 'Please enter a valid property name to proceed.',

  ORGANISATION_ID_IS_STRING_TITLE: 'Organisation ID Required',
  ORGANISATION_ID_IS_STRING_DESCRIPTION: 'You must provide an organisation ID.',
  ORGANISATION_ID_IS_UUID_TITLE: 'Organisation ID Required',
  ORGANISATION_ID_IS_UUID_DESCRIPTION: 'You must provide an organisation ID.',

  PHONE_REQUIRED_TITLE: 'Invalid Phone Number',
  PHONE_REQUIRED_DESCRIPTION: 'Please enter a valid phone number to proceed.',
  PHONE_IS_VALID_TITLE: 'Invalid Phone Number',
  PHONE_IS_VALID_DESCRIPTION: 'Please enter a valid phone number to proceed.',
  PHONE_IS_STRING_TITLE: 'Invalid Phone Number',
  PHONE_IS_STRING_DESCRIPTION: 'Please enter a valid phone number to proceed.',
  PHONE_VERIFIED_BOOLEAN_TITLE: 'Invalid Phone Number',
  PHONE_VERIFIED_BOOLEAN_DESCRIPTION: 'Please enter a valid phone number to proceed.',

  ROLE_ID_IS_STRING_TITLE: 'Invalid Role',
  ROLE_ID_IS_STRING_DESCRIPTION: 'Incorrect role assigned.  Please contact customer support.',

  CURRENT_PASSWORD_REQUIRED_TITLE: 'Password Required',
  CURRENT_PASSWORD_REQUIRED_DESCRIPTION: 'You must provide the current password.',
  CURRENT_PASSWORD_NOT_MATCH_TITLE: 'Password Does Not Match',
  CURRENT_PASSWORD_NOT_MATCH_DESCRIPTION: 'The current password provided does not match our records.',
  NEW_AND_CONFIRM_PASSWORD_NOT_MATCH_TITLE: 'Password Error',
  NEW_AND_CONFIRM_PASSWORD_NOT_MATCH_DESCRIPTION:
    'Please make sure that the new password and confirm password are the same',

  NEW_AND_OLD_PASSWORD_SAME_TITLE: 'New Password Cannot Be the Same',
  NEW_AND_OLD_PASSWORD_SAME_DESCRIPTION: 'The new password you entered is the same as your old one',

  PASSWORD_RESET_LINK_EXPIRED_TITLE: 'Password Reset Link Expired',
  PASSWORD_RESET_LINK_EXPIRED_DESCRIPTION:
    'The password reset link has expired. Please request a new link to reset your password.',

  PASSWORD_INSECURE_TITLE: 'Password Insecure',
  PASSWORD_INSECURE_DESCRIPTION:
    'The password you have chosen is insecure. Please choose a different password.',

  PASSWORD_MIN_LENGTH_TITLE: 'Invalid Password',
  PASSWORD_MIN_LENGTH_DESCRIPTION: 'Password must be 8 characters or more.',
  PASSWORD_MAX_LENGTH_TITLE: 'Invalid Password',
  PASSWORD_MAX_LENGTH_DESCRIPTION: 'Password must be 20 characters or less.',

  CONFIRM_PASSWORD_REQUIRED_TITLE: 'Invalid Password',
  CONFIRM_PASSWORD_REQUIRED_DESCRIPTION: 'Password is required.  Please enter a valid password to proceed.',
  CONFIRM_PASSWORD_MIN_LENGTH_TITLE: 'Invalid Password',
  CONFIRM_PASSWORD_MIN_LENGTH_DESCRIPTION: 'Password must be 8 characters or more.',
  CONFIRM_PASSWORD_MAX_LENGTH_TITLE: 'Invalid Password',
  CONFIRM_PASSWORD_MAX_LENGTH_DESCRIPTION: 'Password must be 20 characters or less.',

  USER_NOT_EXIST_TITLE: 'User Does Not Exist',
  USER_NOT_EXIST_DESCRIPTION: 'User name not recognised.  Please check carefully and try again.',

  USER_PREFERENCE_NOT_EXIST_TITLE: 'User Preference Not Exist',
  USER_PREFERENCE_NOT_EXIST_DESCRIPTION: 'User preference does not exist',

  MARKETING_PREFERENCE_UPDATED_TITLE: 'Marketing preference updated',
  MARKETING_PREFERENCE_UPDATED_DESCRIPTION: 'Marketing preference updated successfully',

  PROFILE_UPDATE_LOCKOUT_DAYS_TITLE: 'Profile update restricted',
  PROFILE_UPDATE_LOCKOUT_DAYS_DESCRIPTION:
    'Email/phone number changes are restricted for a short period. Please try again later.',

  PROFILE_OTP_VERIFICATION_REQUIRED_TITLE: 'Email/Phone number verification required',
  PROFILE_OTP_VERIFICATION_REQUIRED_DESCRIPTION: 'Email/Phone number must be verified with OTP.',

  BANK_STATEMENT_MISSING_CURRENCY_TITLE: 'Currency Selection Required',
  BANK_STATEMENT_MISSING_CURRENCY_DESCRIPTION: 'Please select a currency to generate a bank statement.',
};
